import React from 'react';
import { Tag } from 'antd';
import { includes, isEmpty } from 'ramda';

const { CheckableTag } = Tag;

export default ({ className, dataSource, value, onChange }) => {
  const [checked, setChecked] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([]);

  React.useEffect(() => setSelectedValue(value), [value]);

  const handleChange = (value, checked) => {
    setChecked(checked);
    let values = selectedValue;
    if (isEmpty(values)) {
      values.push(value);
    } else {
      if (includes(value, values)) {
        values.splice(values.indexOf(value), 1);
      } else {
        values = [value];
      }
    }
    setSelectedValue(values);
    onChange(values);
  };

  return (
    <>
      {dataSource.map((item, index) => (
        <CheckableTag
          key={index}
          checked={includes(item.code, selectedValue) ? checked : false}
          className={`pointer ${className}`}
          onChange={(checked) => handleChange(item.code, checked)}
        >
          {item.name}
        </CheckableTag>
      ))}
    </>
  );
};
